/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {defineMessages} from 'react-intl';
import RouteLinkItem from 'components/navigation/side-navigation/item/RouteLinkItem';

const messages = defineMessages({
  title: {id: 'navigation.settings.billing.invoices'},
});

const InvoicesItem = () => (
  <RouteLinkItem
    route="midas/settings/billing/invoices"
    title={messages.title}
  />
);

export default InvoicesItem;
